import { createApi } from "@reduxjs/toolkit/dist/query/react";
import { baseQueryWithAuthInterceptor } from "./util";

export const reasonApi = createApi({
  reducerPath: "reasonApi",
  baseQuery: baseQueryWithAuthInterceptor({ baseUrl: "/api/reason" }),
  tagTypes: ["Reason"],
  endpoints: (builder) => ({
    getReasons: builder.query({
      query: (param) => {
        if (!param || param.length === 0) {
          return "/";
        }
        const typeQuery = encodeURIComponent(JSON.stringify(param));
        return `/?type=${typeQuery}`;
      },
      providesTags: ["Reason"],
    })
  }),
});

export const { 
  useGetReasonsQuery
} = reasonApi;